import Axios from 'axios'
import { API_HOST_TOKEN } from 'constants/appConstants'
import { GET_ACTIVE_SCREENS, GET_SCREEN_CONTENT_TYPES, GET_SCREEN_ZONE } from 'constants/restConstants'

const config = {
  headers: { Authorization: `Bearer ${API_HOST_TOKEN}` },
}

export const getActiveScreens = () => {
  return Axios.get(GET_ACTIVE_SCREENS, config)
}

export const getScreenZone = screenId => {
  return Axios.get(GET_SCREEN_ZONE(screenId), config)
}

export const getScreenContentTypes = screenId => {
  return Axios.get(GET_SCREEN_CONTENT_TYPES(screenId), config)
}
